<template>
  <b-button :disabled="LoadingStartingSurvey" pill :size="size" :variant="variant? variant: survey.button_variant" :class="[{'text-uppercase': !notUpperCase},{'text-light': variant === null}]" @click="surveyStart">
    <loading-spinner v-if="LoadingStartingSurvey">
      {{ $t('button_take_survey_starting') }} {{ $t('button_survey_name_' + survey.slug) }}...
    </loading-spinner>
    <span v-else>
      <slot name="default">{{ $t('button_take_the_survey') }} {{ $t('button_survey_name_' + survey.slug) }} <fa icon="arrow-alt-circle-right" /></slot>
    </span>
  </b-button>
</template>

<script>
import LoadingSpinner from '~/components/LoadingSpinner.vue'

export default {
  name: 'SurveyStartButton',
  components: { LoadingSpinner },
  props: {
    survey: {
      type: Object,
      required: true
    },
    variant: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    notUpperCase: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      LoadingStartingSurvey: false
    }
  },
  methods: {
    async surveyStart () {
      try {
        this.LoadingStartingSurvey = true
        const data = await this.$store.dispatch('surveys/surveyStart', {
          survey_id: this.survey.id
        })
        this.LoadingStartingSurvey = false
        await this.$router.push({ name: 'surveyAnswerSet.start', params: { surveyAnswerSetId: data.id } })
      } catch (e) {
        console.error(e)
        this.LoadingStartingSurvey = false
      }
    }
  }
}
</script>

<style scoped>

</style>
